import { render, staticRenderFns } from "./QScoreCardUniqueWriters.vue?vue&type=template&id=a15cf65e&scoped=true&"
import script from "./QScoreCardUniqueWriters.vue?vue&type=script&lang=js&"
export * from "./QScoreCardUniqueWriters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a15cf65e",
  null
  
)

export default component.exports